import { Component, Input } from '@angular/core';

@Component({
  selector: 'icons-svg',
  templateUrl: 'icons-svg.html'
})
export class IconsSVGComponent {
  @Input() iconName: string;
  @Input() selected: boolean;
  @Input() direction: string;
  @Input() color: string;

  constructor() {}
}



// WEBPACK FOOTER //
// ./src/components/icons/icons-svg/icons-svg.ts